<template>
  <div>
    <div class="c-d-detail" v-html="centDetails.desc"></div>
  </div>
</template>

<script>
export default {
    props: {
        centDetails: {
            default: ''
        },
    },
}
</script>

<style lang="scss">
    .c-d-detail {
        padding: rem(20);
        padding-bottom: rem(40);
        white-space: pre-wrap;
        word-break: break-word;
        img {
            max-width: 100%;
            height: auto;
        }
    }
</style>